import { Run } from '../annotations';

@Run()
export class ImagePreloader {
	constructor() {
		let images: string[] = [
			'/images/computer-aided-design.jpg',
			'/images/construction-management.jpg',
			'/images/procurement.jpg',
			'/images/lighting-systems.jpg',
			'/images/renewable-energy.jpg'
		];

		images.forEach((image: string): void => {
			(new Image()).src = image;
		})
	}
}


/** WEBPACK FOOTER **
 ** ./app/config/image-preloader.ts
 **/